import { __, Alert, confirm } from 'modules/theme';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import Select from 'react-select-plus';
import SelectFilterAPI from '../../../../common/components/form/SelectFilterAPI'
import {
  ModalTrigger,
  Pagination,
  Button,
  ButtonCommonTheme,
  FormControl,
  FormGroup,
  ControlLabel
} from 'modules/theme';
import {
  ModalFooter,
  FormWrapper,
  FormColumn,
  ColumnTitle,
  InfoWrapper
} from 'modules/theme';
// import { APIManager } from '../../../../theme';
import APIManager from 'modules/common/apiManager';

class ComponentAddEdit extends Component {
  constructor(props) {
    super(props);
    this.moduleName = `Sticky Group`;
    this.moduleUrl = `sticky-group`;
    this.saveData = this.saveData.bind(this);
    this.renderFormGroup = this.renderFormGroup.bind(this);
    this.mAPI = new APIManager();
    this.setData(this.props.editData);
  }
  setData(editData = '') {
    editData = editData || {};
    this.state = {
      name: editData.name || '',
      teams: editData.teams || [],
      teamsList: this.getDropData(editData.teams_list || [])
    };
    console.log('edited data', editData);
  }

  getDropData(teamsList) {
    let options = [];
    teamsList = teamsList || [];
    teamsList.map(data => {
      options.push({
        value: data._id,
        label: data.name
      });
    });
    return options;
  }

  renderFormGroup(label, props) {
    return (
      <FormGroup>
        <ControlLabel required={props.required}>{label}</ControlLabel>
        <FormControl {...props} />
      </FormGroup>
    );
  }

  handleSelect(selectedOption, name) {
    this.setState({ [name]: selectedOption ? selectedOption.value : null });
  }

  apiResponse(errorCode, data) {
    if (errorCode === 201) {
      // Alert.success(`${data.message}`);
      let message = data && data.message ? data.message : 'Successfully Done';
      Alert.success(`${message}`);
      this.setData();
      this.props.closeModal(true);
    } else {
      // Alert.error(`${data.message}`);
      let message = data && data.message ? data.message : 'Something wrong happened';
      Alert.error(`${message}`);
    }
  }

  saveData(e) {
    e.preventDefault();
    let _this = this;
    let Name = this.state.name || "";
    Name = Name.trim();
    let tData = {
      name: Name,
      teams: this.state.teams
    };
    if (this.props.editData && this.props.editData._id) {
      this.mAPI.sendPostAPI(
        `${this.moduleUrl}/${this.props.editData._id}`,
        tData,
        data => {
          // console.log(JSON.stringify(data, null, 2));
          if (data) {
            _this.setData();
            _this.props.closeModal(true);
            Alert.success(`${this.moduleName} is Updated.`);
          }
        },
        (errorCode, data) => {
          this.apiResponse(errorCode, data);
        },
        'private',
        { id: tData._id },
        'PUT'
      );
    } else {
      this.mAPI.sendPostAPI(
        `${this.moduleUrl}`,
        tData,
        data => {
          _this.setData();
          _this.props.closeModal(true);
          _this.props.update();
          Alert.success(`${this.moduleName} is Created.`);
        },
        (errorCode, data) => {
          this.apiResponse(errorCode, data);
        }
      );
    }
  }

  render() {
    const { modalType } = this.props;
    // console.log('State Data', this.state);
    return (
      <form onSubmit={e => this.saveData(e)}>
        <FormWrapper>
          <FormColumn>
            {this.renderFormGroup('name', {
              defaultValue: '',
              autoFocus: true,
              required: true,
              id: 'name',
              maxLength: 25,
              value: this.state.name,
              onChange: e => {
                if (e.target && e.target.value) {
                  this.setState({ name: e.target.value });
                } else {
                  this.setState({ name: "" });
                }
              }
            })}
          </FormColumn>
        </FormWrapper>
        <FormWrapper>
          <FormColumn>
            <FormGroup>
              <ControlLabel required={true}>{"Team"}</ControlLabel>
              <SelectFilterAPI
                dataUrl={"team/list"}
                selected={this.state.teams || []}
                initialValues={this.state.teamsList || []}
                label={""}
                name={""}
                multi={true}
                onSelect={(data) => {
                  // console.log("data --", data);
                  this.setState({ teams: data })
                }}
              />
            </FormGroup>
          </FormColumn>
        </FormWrapper>

        <ModalFooter modalType={modalType}>
          <ButtonCommonTheme
            type='greyModalBtn'
            btnStyle="cancel"
            OnClick={() => this.props.closeModal()}
            size="xl"
          >
            Cancel
          </ButtonCommonTheme>
          <ButtonCommonTheme
            type="blueModalBtn"
            btnType="submit"
            btnStyle="default"
            size="xl"
            style={{ float: 'right' }}
          >
            {this.props.editData && this.props.editData._id ? 'Update' : 'Add'}
          </ButtonCommonTheme>
        </ModalFooter>
      </form>
    );
  }
}

ComponentAddEdit.propTypes = {
  group: PropTypes.array
};

ComponentAddEdit.contextTypes = {
  __: PropTypes.func,
  closeModel: PropTypes.func.isRequired
};

export default ComponentAddEdit;



// WEBPACK FOOTER //
// src/modules/screens/settings/StickyAgent/components/ComponentAddEdit.js